import React, { useState } from 'react';
import InfoRow from "../../MisVisitasCreation/components/components/InfoRow/InfoRow";
import CardBox from "../../MisVisitasCreation/components/components/CardBox/CardBox";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Divider,
    Grid,
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

export const CabeceraContratoContent = ({
    infoGeneral,
    profesionales,
    misVisitas,
    notNotifications = true,
    idProfesionalSelected,
    handleProfesionalChange
}) => {
    const [expanded, setExpanded] = useState(false);
    const tipoProfesional = profesionales?.find(p => p.id === idProfesionalSelected) || {};

    const onChangeProfesional = (id) => {
        const newProfesional = profesionales?.find(p => p.id === id);
        handleProfesionalChange(id, newProfesional.idTipoProfesional, newProfesional.idFiguraProfesional, newProfesional.figuraProfesional);
    }

    const handleAccordionChange = (event, isExpanded) => {
        setExpanded(isExpanded);
    }

    return (
        <CardBox>
            <Accordion 
                disableGutters 
                elevation={0} 
                square 
                sx={{ '&:before': { display: 'none', }, }}
                onChange={handleAccordionChange}
            >
                <AccordionSummary
                    expandIcon={
                        <>
                            {infoGeneral?.periodoSuspension && !expanded && (
                                <PriorityHighIcon 
                                    sx={{ 
                                        height: '20px',
                                        color: 'rgba(255, 0, 0, 0.8)',
                                        backgroundColor: 'rgba(255, 0, 0, 0.286)',
                                        borderRadius: '5px',
                                        padding: '2px'
                                    }}
                                />
                            )}
                            <ArrowDropDownIcon />
                        </>
                    }
                    sx={{
                        paddingY: 0,
                        minHeight: 'auto',
                        '& .MuiAccordionSummary-content': {
                            margin: 0,
                        },
                    }}
                >
                    <InfoRow label="HC" value={infoGeneral?.idPaciente} />
                </AccordionSummary>
                <AccordionDetails sx={{ paddingTop: 0, paddingBottom: 0 }}>
                    <Grid container>
                        <InfoRow label="Paciente" value={infoGeneral?.paciente} />
                        <InfoRow label="Código SAP" value={infoGeneral?.codigoSAP} />
                        <InfoRow label="Estado Paciente" value={infoGeneral?.estadoPaciente} />
                        {!!infoGeneral?.periodoSuspension && <Grid 
                            size={{ xs: 12, sm: 6, md: 6, lg: 4 }} 
                            sx={{ borderRadius: '5px', bgcolor: 'rgba(255, 0, 0, 0.286)', padding: '5px'}}
                        >
                            <InfoRow 
                                label="Periodo de Suspensión" 
                                value={infoGeneral?.periodoSuspension} 
                            />
                        </Grid>}
                        {misVisitas && notNotifications && <InfoRow label="Dirección" value={infoGeneral?.direccion} />}
                        <InfoRow label="#" value={infoGeneral?.idEvaluacion} />
                        <InfoRow label="Programa" value={infoGeneral?.programa} />
                        <InfoRow label="Plan" value={infoGeneral?.planCuidado} />
                        {misVisitas && notNotifications && <InfoRow label="Fecha Asignación" value={`(${infoGeneral?.fechaAsignacion})`} />}
                        {misVisitas && notNotifications && <InfoRow label="Frecuencia" value={infoGeneral?.frecuencia} />}
                        {misVisitas && notNotifications && <InfoRow label="Visitas Programadas"
                            value={`${infoGeneral?.cantidadVisitas}/${infoGeneral?.cantidadVisitasEsperadas}`} />}
                        {misVisitas && notNotifications && <InfoRow label="Urgencias" value={infoGeneral?.urgencias} />}
                        {!misVisitas && notNotifications && <Grid size={{ xs: 12 }} sx={{ marginY: '10px' }}>
                            <RenderInputByTypeMobile
                                value={idProfesionalSelected}
                                handleChange={(_, value) => onChangeProfesional(value)}
                                input={{
                                    displayName: 'Profesional',
                                    name: 'idProfesionalSelected',
                                    type: "select",
                                    options: profesionales,
                                }}
                            />
                        </Grid>}
                        {!misVisitas && notNotifications && <InfoRow label="Tipo Profesional"
                            value={tipoProfesional?.descripcion || ''} />}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </CardBox>
    )
}